<template>
  <div class="container md:mx-auto mx-0 mt-6 h-full">
    <component
      :api-key="apiKey"
      :is="
        isOrgSubscriptionActive
          ? 'rele-payments-with-subscription'
          : 'rele-payments-no-subscription'
      "
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"

// stripe public key
const STRIPE_PUBLIC_KEY =
  process.env.VUE_APP_FIRE_ENV === "production"
    ? "pk_live_51H9XhmLiX9O0GzHLKYfgb1N58OP8WtkSnmiXaNAnhHaDVyC8MifHmXlceGQx5UnBRFcDt9wFi8aWHHmzhut8yM77000ChtaAy4"
    : "pk_test_51HRvCWKrUUHYJABv3mJzgMmDQ6TcTCba5kWGAmTSv96ozVrgFQqk9OaYPHtEK07pgIdMHqIjZmhw2KQxJRTpriu9007ytk6jg2"

/**
 * Define the payments page
 */
export default {
  /**
   * Component data
   */
  data() {
    return {
      // active api key
      apiKey: STRIPE_PUBLIC_KEY
    }
  },

  // Calculated props
  computed: {
    ...mapGetters({
      jwt: "auth/getIdToken",
      selectedOrg: "auth/getSelectedOrg",
      org: "orgs/getDoc"
    }),

    /**
     * Check if the organization subscription is active
     */
    isOrgSubscriptionActive() {
      return Boolean(this.org?.subscription)
    }
  }
}
</script>
